import React from 'react';
import TickIcon from '../../../../assets/images/feed/tick_circle.svg';

function ProfileCompletionCompleted() {
    return (<div className="profile-updation-data__completed">
        <img src={TickIcon} alt="profile item completed" />
    </div>)
};

export default ProfileCompletionCompleted;